<template>
  <div>
    <div class="tac" v-if="row.id">
        <p class=" text-color-error el-icon-warning-outline  mb20">若标签被使用更改后会全部更改，请谨慎操作</p>
    </div>
    <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="标签名称" prop="name">
            <el-input v-model="formData.name" autocomplete="off" placeholder="最多输入10个字" />
        </el-form-item>
        <el-form-item label="标签说明" prop="describe">
            <el-input 
                type="textarea" 
                :maxlength="50" 
                show-word-limit 
                v-model="formData.describe" 
                autocomplete="off" 
                placeholder="最多输入50个字"
            />
        </el-form-item>
    </el-form>
    <div  class="tac">
        <el-button @click="$emit('close')">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'WorkOrderTagModal',
    props: ['cbs', 'row'],
    data() {
        const { name = '', describe = '' } = this.row;
        return {
            loading: false,
            formData: {
                name,
                describe
            },
            rules: {
                name: [
                    { required: true, message: '请输入标签名称', trigger: 'blur' },
                    { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        async submitForm() {
            await this.$refs.formRef.validate();
            this.loading = true;
            await this.cbs.onSubmit({ ...this.formData });
            this.loading = false;
           
        }
    }
}
</script>

<style lang="scss" scoped>

</style>